(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire07df"];
var parcelRegister = parcelRequire.register;
parcelRegister("d4u6f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee17ad9b84c6dd35$export$2e2bcd8739ae039; });

var $2hYdk = parcelRequire("2hYdk");

var $5ayqG = parcelRequire("5ayqG");

var $3tZSl = parcelRequire("3tZSl");

var $lSX0J = parcelRequire("lSX0J");
// TODO: Take a look at add to cart in Jane data source
const $ee17ad9b84c6dd35$var$janeDataSource = (snowplow)=>{
    const handler = (0, $lSX0J.multiAdapterHandler)(snowplow);
    handler.add("PostMessageSource", ()=>{
        (0, $5ayqG.postMessageSource)((event)=>{
            const { payload: payload, messageType: messageType } = event.data;
            if (!payload || messageType !== "analyticsEvent") return;
            if (payload.name === "cartItemAdd") {
                const { product: product, productId: productId } = payload.properties;
            //! TODO: Fix this since it's not working
            // addToCartEvent({
            //   sku: productId.toString(),
            //   name: (product.name || "N/A").toString(),
            //   category: (product.category || "N/A").toString(),
            //   unitPrice: parseFloat(product.price || 0),
            //   quantity: parseInt(product.quantity || 1),
            //   currency: "USD",
            // });
            }
            if (payload.name === "cartItemRemoval") {
                const { productId: productId } = payload.properties;
                // Hardcoded because most fields are empty
                (0, $2hYdk.default).notify({
                    removeFromCartEvent: {
                        sku: productId.toString(),
                        name: "N/A",
                        category: "N/A",
                        unitPrice: 0,
                        quantity: 1,
                        currency: "USD"
                    }
                });
            }
            if (payload.name === "checkout") try {
                const { customerEmail: customerEmail, products: products, cartId: cartId, estimatedTotal: estimatedTotal, deliveryFee: deliveryFee, deliveryAddress: deliveryAddress = {}, salesTax: salesTax, storeTax: storeTax, discountTotal: discountTotal } = payload.properties;
                (0, $2hYdk.default).notify({
                    transactionEvent: {
                        userId: customerEmail,
                        id: cartId.toString(),
                        total: parseFloat(estimatedTotal),
                        tax: parseFloat(salesTax + storeTax || 0),
                        shipping: parseFloat(deliveryFee || 0),
                        city: ((deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.city) || "N/A").toString(),
                        state: ((deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.state_code) || "N/A").toString(),
                        country: ((deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.country_code) || "N/A").toString(),
                        discount: parseFloat(discountTotal || 0),
                        couponCode: "N/A",
                        currency: "USD",
                        items: products.map((product)=>{
                            const { product_id: product_id, name: name, category: category, unit_price: unit_price, count: count } = product;
                            return {
                                orderId: cartId.toString(),
                                sku: product_id.toString(),
                                name: (name || "N/A").toString(),
                                category: (category || "N/A").toString(),
                                unitPrice: parseFloat(unit_price || 0),
                                quantity: parseInt(count || 1),
                                currency: "USD"
                            };
                        })
                    }
                });
            } catch (error) {
            // window.tracker("trackError", JSON.stringify(error), "JANE");
            }
        });
    });
    handler.add("DataLayerSource", ()=>{
        (0, $3tZSl.datalayerSource)((data)=>{
            var _data_ecommerce;
            const purchase = (_data_ecommerce = data.ecommerce) === null || _data_ecommerce === void 0 ? void 0 : _data_ecommerce.purchase;
            const products = (purchase === null || purchase === void 0 ? void 0 : purchase.products) || [];
            const event = data.event;
            // No add to cart event found on the datalayer
            if (event === "ihj_purchase") (0, $2hYdk.default).notify({
                transactionEvent: {
                    userId: purchase.customerEmail,
                    id: purchase.transaction_id.toString(),
                    total: parseFloat(purchase.value),
                    tax: 0,
                    shipping: 0,
                    city: "N/A",
                    state: "N/A",
                    country: "N/A",
                    currency: "USD",
                    items: products.map((product)=>{
                        const { name: name, category: category, price: price, quantity: quantity } = product;
                        return {
                            orderId: purchase.transaction_id.toString(),
                            sku: "N/A",
                            name: (name || "N/A").toString(),
                            category: (category || "N/A").toString(),
                            unitPrice: parseFloat(price || 0),
                            quantity: parseInt(quantity || 1),
                            currency: "USD"
                        };
                    })
                }
            });
        });
    });
    handler.execute();
};
var $ee17ad9b84c6dd35$export$2e2bcd8739ae039 = $ee17ad9b84c6dd35$var$janeDataSource;

});
parcelRegister("5ayqG", function(module, exports) {

$parcel$export(module.exports, "postMessageSource", function () { return $5b9746592ec0dabd$export$653284ea2e114aa2; });
const $5b9746592ec0dabd$export$653284ea2e114aa2 = (callback)=>{
    window.addEventListener("message", callback, false);
};

});

parcelRegister("lSX0J", function(module, exports) {

$parcel$export(module.exports, "multiAdapterHandler", function () { return $126ed817d3cdab1d$export$606da16facbf2a29; });

var $lwczO = parcelRequire("lwczO");

var $2hYdk = parcelRequire("2hYdk");
const $126ed817d3cdab1d$export$a2b49bbac3f322 = (snowplow)=>{
    const snowplowContext = snowplow.context.appId;
    let successLogged = false;
    const fns = [];
    function isUnique(name) {
        return fns.findIndex((fn)=>fn.name === name) === -1;
    }
    return {
        add: (name, fn)=>{
            (0, $lwczO.default).info(`Adding ${name} to the adapter handler...`);
            fns.push({
                name: name,
                fn: fn
            });
        },
        execute: ()=>{
            (0, $lwczO.default).info(`Executing adapter handler...`);
            for (const { name: name, fn: fn } of fns){
                let success = false;
                (0, $2hYdk.default).subscribe((event)=>{
                    if (event.transactionEvent) success = true;
                });
                try {
                    (0, $lwczO.default).info(`Attempting transaction with ${name}`);
                    fn();
                    if (success) {
                        successLogged = true;
                        (0, $lwczO.default).info(`Transaction successful with ${name}`);
                        return;
                    }
                } catch (error) {
                    (0, $lwczO.default).error(`Transaction Failed with ${name}`, error);
                }
            }
            if (!successLogged) (0, $lwczO.default).error("All transaction attempts failed for the adapter.");
        }
    };
};
const $126ed817d3cdab1d$export$606da16facbf2a29 = (()=>{
    let instance = null;
    return (snowplow)=>{
        if (!instance) instance = $126ed817d3cdab1d$export$a2b49bbac3f322(snowplow);
        return instance;
    };
})();

});


})();
//# sourceMappingURL=jane.d0089c80.js.map
